import React from 'react'

// import ImgCardClick from './shared/ImgCardClick'

import clermontcommunaute from '../assets/sponsors/clermontco.jpg'
import noris from '../assets/sponsors/noris.jpg'
import ceyrat from '../assets/sponsors/ceyrat.jpg'
import ca from '../assets/sponsors/ca.png'

const Sponsors = () => {
  const sponsors = [
     { link: "https://www.clermontmetropole.eu/accueil/", img: clermontcommunaute, alt: "Clermont Communauté", category: "Partenaire" },
     { link: "https://noris-sfjam.fr/", img: noris, alt: "Noris", category: "Partenaire" },
     { link: "https://www.ceyrat.fr/", img: ceyrat, alt: "Ville de Ceyrat", category: "Partenaire" },
     { link: "https://www.credit-agricole.fr/particulier/agence/centre-france.html", img: ca, alt: "Credit Agricole", category: "Partenaire" }
  ];

  return (
    <section className="relative py-20 bg-gradient-to-br from-gray-50 to-white overflow-hidden">
      {/* Éléments décoratifs */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-primary/5 to-red-100/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-gradient-to-tl from-red-50/30 to-primary/5 rounded-full blur-3xl"></div>
      
      <div className="relative container mx-auto px-6 lg:px-8">
        {/* En-tête de section */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-primary to-red-600 text-white text-sm font-semibold rounded-full mb-6">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
            </svg>
            Nos partenaires
          </div>
          {/* <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Un réseau de <span className="text-primary">confiance</span>
          </h2> */}
          {/* <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Nous collaborons avec les meilleures écoles et organisations de karaté 
            pour offrir un enseignement de qualité et développer notre art martial.
          </p> */}
        </div>

        {/* Grille des partenaires */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8 mb-16">
          {sponsors.map((sponsor, index) => (
            <div key={index} className="group">
              <div className="bg-white rounded-2xl sm:rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 p-4 sm:p-6 lg:p-8 h-full">
                {/* Badge catégorie */}
                <div className="flex justify-between items-start mb-4 sm:mb-6">
                  <span className="inline-flex items-center px-2 sm:px-3 py-1 bg-gray-100 text-gray-700 text-xs font-semibold rounded-full">
                    {sponsor.category}
                  </span>
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 group-hover:text-primary transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
                  </svg>
                </div>

                {/* Logo */}
                <div className="flex items-center justify-center mb-4 sm:mb-6 h-24 sm:h-28 lg:h-32">
                  <a 
                    href={sponsor.link} 
                    target="_blank" 
                    rel="noreferrer"
                    className="block w-full h-full group-hover:scale-105 transition-transform duration-300"
                  >
                    <img
                      src={sponsor.img}
                      className="w-full h-full object-contain filter group-hover:brightness-110 transition-all duration-300"
                      alt={sponsor.alt}
                    />
                  </a>
                </div>

                {/* Nom du partenaire */}
                <div className="text-center">
                  <h3 className="text-sm sm:text-base lg:text-lg font-semibold text-gray-900 group-hover:text-primary transition-colors duration-300">
                    {sponsor.alt}
                  </h3>
                </div>

                {/* Effet décoratif */}
                <div className="absolute bottom-0 right-0 w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20 bg-gradient-to-br from-primary/5 to-red-100/10 rounded-tl-2xl sm:rounded-tl-3xl"></div>
              </div>
            </div>
          ))}
        </div>

        {/* Section valeurs du partenariat */}
        <div className="bg-white rounded-3xl shadow-xl p-6 md:p-8 border border-gray-100">
          <div className="text-center mb-8 md:mb-12">
            <h3 className="text-xl md:text-3xl font-bold text-gray-900 mb-4">Nos valeurs partagées</h3>
            {/* <p className="text-gray-600 max-w-2xl mx-auto">
              Des partenariats basés sur l'excellence, le respect et la passion des arts martiaux
            </p> */}
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            <div className="text-center">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
                </svg>
              </div>
              <h4 className="text-sm md:text-lg font-bold text-gray-900 mb-1 md:mb-2">Excellence</h4>
              <p className="text-gray-600 text-xs md:text-sm">
                Recherche constante de la qualité dans l'enseignement
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.196-2.121M17 20v-2a3 3 0 00-3-3H4a3 3 0 00-3 3v2h16zM4 10a3 3 0 106 0 3 3 0 00-6 0z"></path>
                </svg>
              </div>
              <h4 className="text-sm md:text-lg font-bold text-gray-900 mb-1 md:mb-2">Partage</h4>
              <p className="text-gray-600 text-xs md:text-sm">
                Échange d'expériences et de techniques
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                </svg>
              </div>
              <h4 className="text-sm md:text-lg font-bold text-gray-900 mb-1 md:mb-2">Innovation</h4>
              <p className="text-gray-600 text-xs md:text-sm">
                Évolution constante de nos méthodes
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
                </svg>
              </div>
              <h4 className="text-sm md:text-lg font-bold text-gray-900 mb-1 md:mb-2">Tradition</h4>
              <p className="text-gray-600 text-xs md:text-sm">
                Respect des valeurs ancestrales du karaté
              </p>
            </div>
          </div>
        </div>

        {/* Call to action */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-primary to-red-600 rounded-3xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">Vous souhaitez devenir partenaire ?</h3>
            <p className="text-gray-100 mb-6 max-w-2xl mx-auto">
              Rejoignez notre réseau et participez au développement des arts martiaux dans la région.
            </p>
            <a 
              href="mailto:ecolecksd@gmail.com?subject=Partenariat ECKSD"
              className="inline-flex items-center px-8 py-4 bg-white text-primary font-semibold rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
            >
              <span>Nous contacter</span>
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Sponsors